import React from 'react';
import { FaBuilding, FaRoad, FaWater, FaWrench, FaBolt, FaShieldAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const Projects = () => {
    const projectData = [
        {
            title: 'Bridges',
            description: 'Maintenance, repairs, and painting for all types of bridges.',
            icon: <FaWrench />
        },
        {
            title: 'Roads',
            description: 'RCC roads, paver blocks, and trimix footpaths.',
            icon: <FaRoad />
        },
        {
            title: 'Buildings',
            description: 'Maintenance, repairs, and painting for all types of buildings.',
            icon: <FaBuilding />
        },
        {
            title: 'Pipelines',
            description: 'Jointing, painting, and coating for pipelines.',
            icon: <FaWater />
        },
        {
            title: 'RCC Structural',
            description: 'Structural repairs, polymer plaster (PMM), and micro-concrete.',
            icon: <FaBolt />
        },
        {
            title: 'Guniting, Sand Blasting',
            description: 'Guniting, sand blasting, and jacketing services.',
            icon: <FaShieldAlt />
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 50, scale: 0.8 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };

    return (
        <div className="bg-gradient-to-b from-gray-50 to-white py-16 sm:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    eyebrow="What We Do"
                    title="Areas of Operation"
                />

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                >
                {projectData.map((project, index) => (
                        <motion.div
                        key={index} 
                            variants={itemVariants}
                            whileHover={{ 
                                y: -10,
                                scale: 1.03,
                                transition: { duration: 0.3 }
                            }}
                            className="relative group"
                        >
                            {/* Glass morphism card matching StatsSection */}
                            <div className="bg-white/90 backdrop-blur-lg rounded-2xl p-6 border border-gray-200 shadow-lg hover:shadow-2xl hover:border-brand-yellow transition-all duration-300 h-full">
                                {/* Icon */}
                                <motion.div
                                    whileHover={{ rotate: 360, scale: 1.2 }}
                                    transition={{ duration: 0.6 }}
                                    className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-brand-navy to-brand-navy-light flex items-center justify-center shadow-lg"
                                >
                                    <div className="text-3xl sm:text-4xl text-brand-yellow">
                                        {project.icon}
                        </div>
                                </motion.div>

                                {/* Title */}
                                <h3 className="text-lg sm:text-xl font-bold text-gray-900 text-center mb-3 group-hover:text-brand-navy transition-colors duration-300">
                                    {project.title}
                                </h3>

                                {/* Description */}
                                <p className="text-sm text-gray-600 text-center group-hover:text-gray-900 transition-colors duration-300">
                                    {project.description}
                                </p>

                                {/* Hover glow effect like StatsSection */}
                                <div className="absolute inset-0 bg-gradient-to-br from-brand-navy to-brand-navy-light opacity-0 group-hover:opacity-10 rounded-2xl blur-xl transition-opacity duration-300" />
                        </div>
                        </motion.div>
                ))}
                </motion.div>
            </div>
        </div>
    );
};

export default Projects;
